import { RouteRecordRaw } from "vue-router";
import { AuthGuardService } from "@/_guard/AuthGuardService";

const auth = new AuthGuardService();

export const AuthRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'viewAuthLogin',
    meta: {title: 'Login'},
    component: () => import('@/modules/auth/views/viewAuthLogin.vue'),
    beforeEnter: auth.guest
  },

  {
    path: '/signup',
    name: 'viewAuthSignup',
    meta: {title: 'Signup'},
    component: () => import('@/modules/auth/views/viewAuthSignup.vue'),
    beforeEnter: auth.guest
  },

  {
    path: '/signup-success',
    name: 'viewAuthSignupSuccess',
    meta: {title: 'Signup Success'},
    component: () => import('@/modules/auth/views/viewAuthSignupSuccess.vue'),
  },

  {
    path: '/change-password',
    name: 'viewAuthChangePassword',
    meta: {title: 'Change Password'},
    component: () => import('@/modules/auth/views/viewAuthChangePassword.vue'),
  },

  {
    path: '/verify-signup',
    name: 'viewAuthVerifySignup',
    meta: {title: 'Verify Signup'},
    component: () => import('@/modules/auth/views/viewAuthVerifySignup.vue'),
  },

  {
    path: '/reset-password',
    name: 'viewAuthResetPassword',
    meta: {title: 'Reset Password'},
    component: () => import('@/modules/auth/views/viewAuthResetPassword.vue'),
  },
];